import React from 'react';
import { Typography, TypographyOwnProps } from '@mui/material';
import { FormattedTextField } from 'framework/ui/field';
import { useDateService } from 'framework/utils';
import InfoRow from './InfoRow';
import InfoCard from './InfoCard';
import moment from 'moment';

const getStatusUpdateColor = (statusDate: string): TypographyOwnProps['color'] => {
  if (!statusDate) return 'textSecondary';

  const today = new Date();
  const statusUpdateDate = new Date(statusDate);
  const diffTime = Math.abs(today.getTime() - statusUpdateDate.getTime());
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  if (diffDays < 7) return 'success';
  if (diffDays <= 14) return 'warning';
  return 'error';
};

const ProjectInfo: React.FC = () => {
  const { getToday, datesDifference } = useDateService();

  return (
    <InfoCard title="Project information">
      <InfoRow label="Status update">
        <FormattedTextField
          label=""
          source="projectInfo.statusUpdate"
          format={(str: string) => (
            <Typography color={getStatusUpdateColor(str)}>{datesDifference(getToday(), str) || '—'}</Typography>
          )}
        />
      </InfoRow>

      <InfoRow label="Scope completion, %">
        <FormattedTextField
          label=""
          source="projectInfo.scopeCompletionPercentage"
          format={(str: string) => (!str ? '—' : `${str}%`)}
        />
      </InfoRow>

      <InfoRow label="Kickoff meeting">
        <FormattedTextField
          label=""
          source="projectInfo.kickoffMeetingDate"
          format={(str: string) => datesDifference(getToday(), str)}
        />
      </InfoRow>

      <InfoRow label="Original release">
        <FormattedTextField
          label=""
          source="projectInfo.originalReleaseDate"
          format={(str: string) =>
            moment(str).isAfter(getToday())
              ? `in ${datesDifference(getToday(), str)}`
              : datesDifference(getToday(), str) || ''
          }
        />
      </InfoRow>

      <InfoRow label="Projected release" isLast>
        <FormattedTextField
          label=""
          source="projectInfo.projectedReleaseDate"
          format={(str: string) =>
            moment(str).isAfter(getToday())
              ? `in ${datesDifference(getToday(), str)}`
              : datesDifference(getToday(), str) || ''
          }
        />
      </InfoRow>
    </InfoCard>
  );
};

export default ProjectInfo;
